import React from 'react';
import PropTypes from 'prop-types';
import './SkuSelectComp.less';
import autobind from 'autobind-decorator';
import { addShop } from '../../operates';
import { toast } from '../../components/notice';
import store from '../../store';
import { _equipmentType, getParam, getUrlParam, push } from '../../utils';
import { getCookie } from '../../utils/network';

interface SkuSelectCompPropType {
    prefixCls?: any;
    user: any;
    productId: any;
    hideHomeJia: any;
    isShow: boolean;
    selectSkuId: any;
    skoData: any;
    rankDetail: any;
    pageId?: any; // 页面来源
}

interface SkuSelectCompState {
    selectNumber: number;
    curProImg: string;
    selSkuPrice: any;
    selSkuInfo: any;
    selPropInfo: any;
    oriData?: any;
    selSku: any[];
}

declare var window: any;

class SkuSelectComp extends React.Component<SkuSelectCompPropType, SkuSelectCompState> {
    static defaultProps = {
        prefixCls: 'skuSelectComp'
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            selectNumber: 1, // 选择数量
            curProImg: '', // 选中展示的图片
            selSkuPrice: null, // 选中的sku价格
            selSkuInfo: [],
            selPropInfo: '',
            oriData: {},
            selSku: [], // 存储已选择的sku，propId
        };
    }

    selectSkuId: any = ''; // 选中的skuID
    mainImg: any = ''; // 主图
    kuCun: any = ''; // 库存数量
    isCanAdd: boolean = false; // 是否选择了规格
    defaultSkuId: any;
    defaultSku: any;
    skuMarketPrice: any = '';

    componentDidMount() {
        let that = this;
        this.selectSkuId = this.props.selectSkuId;
        this.setState({
            oriData: this.props.skoData
        });
        setTimeout(function () {
            that.accessData(that.props.skoData);
        }, 10);
    }

    @autobind
    accessData(data): void {
        if (!this.defaultSkuId) {
            if (sessionStorage.getItem('__skuId')) {
                for (let i = 0; i < data.skuList.length; i++) {
                    if (data.skuList[i].skuId == sessionStorage.getItem('__skuId')) {
                        this.defaultSku = data.skuList[i];
                    }
                }
            } else if (data.skuList.length === 1) {
                this.defaultSku = data.skuList[0];
            }
        } else {
            var skuList = data.skuList;
            for (var i = 0, flen = skuList.length; i < flen; i++) {
                if (!skuList[i]) continue;
                var sku = skuList[i];
                if (sku.skuId === this.defaultSkuId) {
                    this.defaultSku = sku;
                    break;
                }
            }
        }
        if (this.defaultSku !== null && this.defaultSku !== undefined && this.defaultSku.stock) {
            var typeArr = this.defaultSku.skuKey.split(';');
            data['propList'].map((item, index) => {
                return item.types.map((pro) => {
                    if (pro.propId === typeArr[index]) {
                        let that = this;
                        setTimeout(function () {
                            that.handleSkuState(pro, index);
                        }, 0);
                    }
                    return null;
                });
            });
        }
    }


    /* 隐藏规格选择框 */
    @autobind
    closeSelectBox(e): void {
        let evt: any = e.currentTarget || e.target;
        this.props.hideHomeJia();
        let that = this;
        setTimeout(function () {
            if (evt && evt.className !== 'skuSelectCompselect_box_close') {
                let sendData: object = {
                    data: that.selectSkuId,
                    selectNumber: that.state.selectNumber
                };
                if (getCookie("pub-token") === "") {
                    sessionStorage.setItem("addShopData", JSON.stringify(sendData))
                    sessionStorage.setItem('oldPage', `home`)
                    push("/loginPage/addShop?originPage=home", that)
                } else {
                    addShop(sendData, that.props.user, (isRun) => {
                        if (isRun) return;
                        if (store.status.isApp) {
                            let osData: object = { cmd: 'shopcart', type: 'add', param: 'add shop cart' };
                            window.postMessage(JSON.stringify(osData), '*');
                        }
                        if (that.selectSkuId) {
                            sessionStorage.setItem('__shop', that.selectSkuId);
                        }
                    });
                    store.user.shopNum()
                    that.props.hideHomeJia((Math.random()).toString())
                    // burialPoint('burialpoint/logShopCar', {
                    //     body: JSON.stringify(that._transformBurialPointData({
                    //         skuId: that.selectSkuId,
                    //         productPrice: that.state.selSkuPrice,
                    //         pageProductId: that.props.productId
                    //     }))
                    // });
                }
            }
        }, 400);
    }

    @autobind
    _transformBurialPointData(obj: any = {}): Object {
        let newObj: Object = {
            user: {
                userType: 1,
                serviceType: store.status.isApp ? 'B' : 'C',
                clientType: store.status.isApp ? 1 : store.status.gameApp ? 3 : 4,
                osTypeId: _equipmentType(),
            },
            page: {
                pageId: this.props.pageId || '',
                originPageId: getUrlParam('originPageId'),
            },
            product: {
                pageProductId: obj.pageProductId,
                originType: this.props.pageId == 'subject' ? 2 : '3',
                addShopCart: 2,
                skuId: obj.skuId,
                productPrice: obj.productPrice,
                subjectId: this.props.pageId == 'subject' ? getParam('id', this) : getUrlParam('subjectId')
            }
        };
        return newObj;
    }

    /* 渲染过程中，判断属性按钮是否需要置灰 */
    @autobind
    comSkuExist(pro, index): any {
        let that = this;
        if (that.state.oriData) {
            let ret = false,
                tempSku = that.state.selSku.slice(0),
                skuList = that.state.oriData.skuList;
            tempSku[index] = pro.propId;
            let attrCou = this.state.oriData.propList.length;
            if (skuList && skuList.length > 0) {
                for (let s = 0, len = skuList.length; s < len; s++) {
                    if (!skuList[s]) continue;
                    let sku = skuList[s];
                    if (!sku.stock) continue;
                    let propIds = sku.skuKey.split(';');
                    let bsku = true;
                    for (var l = 0; l < attrCou; l++) {
                        bsku = bsku && (!tempSku[l] || propIds[l] === tempSku[l]);
                        if (!bsku) break;
                    }
                    if (bsku) {
                        ret = true;
                        break;
                    }
                }
            }
            return ret;
        }
    }

    /* 点击属性按钮事件处理 */
    @autobind
    handleSkuState(pro, index, e?): void {
        if (e && e.target.className === 'skuSelectCompselect_value_no') {
            this.selectSkuId = '';
            return;
        }
        if (pro) {
            let propList: any = this.state.oriData.propList;
            let selSku: any = this.state.selSku.slice(0);
            let selSkuInfo: any = this.state.selSkuInfo.slice(0);
            let imgPath: any = this.mainImg;
            let selPropInfo: any = '';
            let selSkuPrice: any = null;
            if (propList[index]) {
                // hasSelected代表点击之前的选中状态
                let hasSelected: boolean = !e ? false : e.target.className === 'skuSelectCompselect_value_has';
                let prop: any = propList[index];
                prop.selProp = hasSelected ? '' : pro.propId;
                selSku[index] = hasSelected ? '' : pro.propId;
                selSkuInfo[index] = hasSelected ? '' : pro.propValue;
            }
            selSkuInfo.forEach((name) => {
                if (name) {
                    selPropInfo += name + ' ';
                }
            });
            // 当选择全一个sku时，显示价格和对应图片
            if (selSku.length === propList.length) {
                let m: boolean = true;
                for (let x = 0, xlen = selSku.length; x < xlen; x++) {
                    if (!selSku[x]) {
                        m = false;
                        break;
                    }
                }
                if (m) {
                    let skuList: any = this.state.oriData.skuList;
                    for (let i = 0, llen = skuList.length; i < llen; i++) {
                        if (!skuList[i]) continue;
                        let sku: any = skuList[i];
                        if (sku.skuKey === selSku.join(';') + ';') {
                            selSkuPrice = sku.price;
                            this.skuMarketPrice = sku.marketPrice;
                            this.selectSkuId = sku.skuId;
                            this.kuCun = sku.stock;
                            this.isCanAdd = true;
                            if (this.state.selectNumber > sku.stock) {
                                this.setState({
                                    selectNumber: sku.stock
                                });
                            }
                        }
                    }
                    imgPath = this.getCurProImg(selSku);
                }
            }
            this.setState((prevState) => ({
                oriData: {
                    propList: propList,
                    skuList: prevState.oriData.skuList
                },
                selSku: selSku,
                curProImg: imgPath ? imgPath : '',
                selPropInfo: selPropInfo !== '' ? selPropInfo.slice(0, -1) : '请选择',
                selSkuInfo: selSkuInfo,
                selSkuPrice: selSkuPrice
            }));
        }
    }

    /* 获取当前选择的完整或不完整sku的图片 */
    @autobind
    getCurProImg(selSku): any {
        var retImg = '',
            skuList = this.state.oriData.skuList;
        if (skuList && skuList.length > 0) {
            for (var s = 0, len = skuList.length; s < len; s++) {
                if (!skuList[s]) continue;
                var sku = skuList[s];
                var propIds = sku.skuKey.split(';');
                if (
                    (!selSku[0] || propIds[0] === selSku[0]) &&
                    (!selSku[1] || propIds[1] === selSku[1]) &&
                    (!selSku[2] || propIds[2] === selSku[2])
                ) {
                    retImg = sku.imagePath;
                    break;
                }
            }
            return retImg;
        }
    }

    /* 增加商品数量 */
    @autobind
    addNumber(): any {
        if (this.selectSkuId) {
            if (this.state.selectNumber >= 1) {
                let num: number = this.state.selectNumber;
                ++num;
                if (this.isCanAdd) {
                    if (num > this.kuCun) {
                        num = this.kuCun;
                        if (num == 0) {
                            num = 1;
                        }
                    } else {
                        this.setState({
                            selectNumber: num
                        });
                    }
                } else {
                    toast('请选择规格属性');
                }
            }
        } else {
            this.isCanAdd = false;
            toast('请选择规格属性');
        }
    }

    /* 减少商品数量 */
    @autobind
    reduceNumber(): any {
        if (this.state.selectNumber > 1) {
            let num: number = this.state.selectNumber;
            this.setState({
                selectNumber: --num
            });
        }
    }

    /* 确定事件 */
    @autobind
    sureSelSku(e) {
        let strWarn: string = '请选择';
        let selSku: any = this.state.selSku;
        let propList: any = this.state.oriData.propList;
        if (propList && propList.length > 0) {
            for (let p = 0, len = propList.length; p < len; p++) {
                strWarn += !selSku[p] ? '“' + this.state.oriData.propList[p].propType + '”' : '';
            }
        }
        if (strWarn !== '请选择') {
            toast(strWarn);
        } else {
            // 提交
            let skuList: any = this.state.oriData.skuList;
            if (skuList && skuList.length > 0) {
                for (let i = 0, len = skuList.length; i < len; i++) {
                    if (!skuList[i]) continue;
                    let sku: any = skuList[i];
                    if (sku.skuKey === selSku.join(';') + ';') {
                        if (this.state.selectNumber > sku.stock) {
                            this.setState({
                                selectNumber: sku.stock
                            });
                        }
                        this.closeSelectBox(e);
                        this.selectSkuId = sku.skuId;
                    }
                }
            }
        }
    }

    render() {
        const {prefixCls, isShow, rankDetail} = this.props;
        const {curProImg, selSkuPrice, selPropInfo, selectNumber, oriData} = this.state;
        let dataw = oriData ? oriData : '';
        let data = rankDetail.lists ? rankDetail.lists.productInfo : '';
        return (
            <div>
                <div className={prefixCls + 'cover'}/>
                <div className={isShow ? (prefixCls + 'select_box') : (prefixCls + 'select_box_other')}>
                    <div className={prefixCls + 'select_box_close'} onClick={this.closeSelectBox}/>
                    <div className={prefixCls + 'quanBody'}>
                        <div className={prefixCls + 'select_top'}>
                            <img className={prefixCls + 'select_img'}
                                 src={curProImg ? curProImg : (data && data.mastermap)} alt=""/>
                            <div className={prefixCls + 'select_top_words_box'}>
                                <div className={prefixCls + 'select_money_box'}>
                                    <div
                                        className={prefixCls + 'select_money'}>
                                        ￥{selSkuPrice ? selSkuPrice : (data && data.minPrice)}
                                    </div>
                                    <div
                                        className={prefixCls + 'select_money_market'}>￥{this.skuMarketPrice ? this.skuMarketPrice : (data && data.minMarkPrice)}
                                        <div className={prefixCls + 'select_money_market_line'}/>
                                    </div>
                                </div>
                                <div
                                    className={prefixCls + 'select_money_market_words'}> {selPropInfo === '' ? '请选择规格属性' : '已选择  ' + selPropInfo}  </div>
                            </div>
                        </div>
                        <div className={`${prefixCls}scroll_parent_box`}>
                            {
                                JSON.stringify(dataw) !== '{}' && dataw.skuList.length !== 1 ? dataw['propList'].map((item, index) => {
                                    return (
                                        <div className={prefixCls + 'select_value_box'} key={index}>
                                            <div className={prefixCls + 'select_value_title'}>{item.propType}</div>
                                            {
                                                item['types'].map((pro, index2) => {
                                                    return (<div
                                                        className={!this.comSkuExist(pro, index) ? 'skuSelectCompselect_value_no' : pro.propId === item.selProp ? 'skuSelectCompselect_value_has' : 'skuSelectCompselect_value'}
                                                        key={index2}
                                                        onClick={this.handleSkuState.bind(this, pro, index)}>{pro.propValue}</div>);
                                                })
                                            }
                                        </div>
                                    );
                                }) : JSON.stringify(dataw) !== '{}' && dataw['propList'].map((item, index) => (
                                    <div className={prefixCls + 'select_value_box'} key={index}>
                                        <div className={prefixCls + 'select_value_title'}>{item.propType}</div>
                                        {
                                            <div
                                                className={!this.comSkuExist(item.types[0], index) ? 'skuSelectCompselect_value_no' : item.types[0].propId === item.selProp ? 'skuSelectCompselect_value_has' : 'skuSelectCompselect_value'}
                                                key={item.types[0].propId}
                                                onClick={this.handleSkuState.bind(this, item.types[0], index)}>{item.types[0].propValue}</div>
                                        }
                                    </div>
                                ))
                            }
                            <div className={prefixCls + 'select_value_box'}>
                                <div className={prefixCls + 'select_value_title'}>数量</div>
                                <div className={prefixCls + 'change_number-box'}>
                                    <div className={prefixCls + 'reduce_icon'} onClick={this.addNumber}>
                                        <img src={require('../../images/shop_add.png')} alt=""/>
                                    </div>
                                    <div className={prefixCls + 'number_container'}>{selectNumber}</div>
                                    <div className={prefixCls + 'reduce_icon'} onClick={this.reduceNumber}>
                                        <img src={require('../../images/shop_reduce.png')} alt=""/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={prefixCls + 'select_bottom_btn'} onClick={this.sureSelSku}>确定</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SkuSelectComp;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/skuSelectComp/SkuSelectComp.tsx